/**
 * Chuẩn hóa họ tên: bỏ dấu tiếng Việt, viết hoa, gộp khoảng trắng.
 * @param {string} name
 * @param {{ trimEnds?: boolean }} [options] - trimEnds=false khi đang gõ (giữ space cuối để nhập từ tiếp theo)
 */
export function normalizePersonName(name = "", { trimEnds = true } = {}) {
  let out = String(name || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .replace(/\s+/g, " ")
    .toUpperCase();
  if (trimEnds) out = out.trim();
  return out;
}
